import gql from 'graphql-tag';

export default gql`
  mutation updateOrderCourseCategoryMutation($courseCategories: [UpdateOrderCourseCategoryInput]) {
    updateOrderCourseCategoryMutation(courseCategories: $courseCategories) {
      status
    }
  }
`;
